export const DEFAULT_PREFIX = ' ';
export const CHECK_MARK_SYMBOL = '✅';
export const CHECK_MARK = ` ${CHECK_MARK_SYMBOL}`;
export const PREFIX_XI = 'Ξ';
export const PREFIX_CIRCLE = '⊚';

export const optionPrefix = [
  {
    value: ' ',
    label: 'Empty',
  },
  // {
  //   value: 'µ',
  //   label: 'µ',
  // },
  {
    value: PREFIX_XI,
    label: PREFIX_XI,
  },
  {
    value: PREFIX_CIRCLE,
    label: PREFIX_CIRCLE,
  },
  // {
  //   value: 'π',
  //   label: 'π',
  // },
  // {
  //   value: 'Ω',
  //   label: 'Ω',
  // },
  // {
  //   value: 'ٴ',
  //   label: 'ٴ',
  // },
  // {
  //   value: 'ٴﻩ',
  //   label: 'ٴﻩ',
  // },
];

export const optionOneTap = [
  {
    value: 'oneTap',
    label: 'Do nothing',
  },
  {
    value: 'autoDeclined',
    label: 'End Call',
  },
  {
    value: 'autoAccepted',
    label: 'Receive Call',
  },
];
